/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowForward = createReactComponent("outline", "arrow-forward", "IconArrowForward", [["path", { "d": "M15 11l4 4l-4 4m4 -4h-11a4 4 0 0 1 0 -8h1", "key": "svg-0" }]]);

export { IconArrowForward as default };
//# sourceMappingURL=IconArrowForward.mjs.map
